import { apiUrl } from '../../../settings'

export const searchKeywordUrl = () => {
  return apiUrl + `/searchKeyword`
}
